import { type ReactNode, useId } from "react";

export type DemoNoticeProps = {
  title?: string;
  children: ReactNode;
};

export const DemoNotice = ({ title = "Demonstration only", children }: DemoNoticeProps) => {
  const titleId = useId();

  return (
    <aside className="demo-notice" aria-labelledby={titleId}>
      <p className="demo-notice__label" id={titleId}>
        {title}
      </p>
      <div className="demo-notice__body">{children}</div>
    </aside>
  );
};
